import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Components.css';

const Inventory = ({ medicines, allMedicines, addMedicine, updateStock, recordSale, searchTerm, setSearchTerm }) => {
  const [showForm, setShowForm] = useState(false);
  const [newMed, setNewMed] = useState({ name: '', stock: 0, price: 0, expiryDate: '' });
  const [selectedMedId, setSelectedMedId] = useState('');
  const [saleQty, setSaleQty] = useState(1);

  // Helper: row color based on expiry
  const getExpiryRowColor = (expiryDateStr) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const expiry = new Date(expiryDateStr);
    expiry.setHours(0, 0, 0, 0);
    const diffDays = Math.ceil((expiry - today) / (1000 * 3600 * 24));
    if (diffDays < 0) return '#ffebee';     // expired – light red
    if (diffDays <= 30) return '#fff9c4';   // expiring soon – light yellow
    return 'transparent';
  };

  const handleAddMedicine = (e) => {
    e.preventDefault();
    if (!newMed.name || newMed.stock <= 0 || newMed.price <= 0) return;
    addMedicine(newMed);
    setNewMed({ name: '', stock: 0, price: 0, expiryDate: '' });
    setShowForm(false);
  };

  const handleSale = () => {
    if (!selectedMedId) return;
    const medicine = allMedicines.find(m => m._id === selectedMedId);
    if (!medicine || saleQty <= 0 || saleQty > medicine.stock) {
      alert('Invalid quantity or insufficient stock');
      return;
    }
    const amount = saleQty * medicine.price;
    recordSale({ medicineId: selectedMedId, quantitySold: saleQty, amount });
    setSelectedMedId('');
    setSaleQty(1);
    alert(`Sold ${saleQty} x ${medicine.name} for ₹${amount.toFixed(2)}`);
  };

  return (
    <div className="card inventory-card">
      <div className="inventory-header">
        <h2>📦 Inventory Management</h2>
        <button onClick={() => setShowForm(!showForm)} className="btn-add">
          {showForm ? 'Cancel' : '+ Add Medicine'}
        </button>
      </div>

      {/* Search Bar */}
      <div className="search-section">
        <input
          type="text"
          placeholder="🔍 Search medicine by name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        {searchTerm && (
          <button onClick={() => setSearchTerm('')} className="btn-clear">
            Clear
          </button>
        )}
      </div>

      {showForm && (
        <form onSubmit={handleAddMedicine} className="medicine-form">
          <input type="text" placeholder="Medicine name" value={newMed.name} onChange={e => setNewMed({...newMed, name: e.target.value})} required />
          <input type="number" placeholder="Stock quantity" value={newMed.stock} onChange={e => setNewMed({...newMed, stock: parseInt(e.target.value)})} required />
          <input type="number" step="0.01" placeholder="Price (₹)" value={newMed.price} onChange={e => setNewMed({...newMed, price: parseFloat(e.target.value)})} required />
          <input type="date" placeholder="Expiry date" value={newMed.expiryDate} onChange={e => setNewMed({...newMed, expiryDate: e.target.value})} required />
          <button type="submit" className="btn-submit">Add to Inventory</button>
        </form>
      )}

      <div className="sale-section">
        <h3>💊 Record a Sale</h3>
        <select value={selectedMedId} onChange={e => setSelectedMedId(e.target.value)}>
          <option value="">Select Medicine</option>
          {allMedicines.map(med => (
            <option key={med._id} value={med._id}>
              {med.name} (Stock: {med.stock} | ₹{med.price})
            </option>
          ))}
        </select>
        <input type="number" min="1" placeholder="Quantity" value={saleQty} onChange={e => setSaleQty(parseInt(e.target.value))} />
        <button onClick={handleSale} disabled={!selectedMedId} className="btn-sale">Record Sale</button>
      </div>

      <table className="inventory-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Stock</th>
            <th>Price (₹)</th>
            <th>Expiry</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {medicines.length === 0 ? (
            <tr><td colSpan="5" style={{textAlign:'center'}}>No medicines found</td></tr>
          ) : (
            medicines.map(med => (
              <tr key={med._id} style={{ backgroundColor: getExpiryRowColor(med.expiryDate) }}>
                <td>{med.name}</td>
                <td className={med.stock < 20 ? 'low-stock' : ''}>{med.stock}</td>
                <td>₹{med.price.toFixed(2)}</td>
                <td>{new Date(med.expiryDate).toLocaleDateString()}</td>
                <td>
                  <Link to={`/edit-medicine/${med._id}`} className="btn-edit">Edit</Link>
                  <button onClick={() => updateStock(med._id, 10)} className="btn-restock">+10</button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Inventory;